import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const AppBarActionsContext = createContext(null);

export const AppBarActionsProvider = ({ children }) => {
  const [actions, setActions] = useState(null);

  const setAppBarActions = useCallback((nextActions) => {
    setActions(nextActions || null);
  }, []);

  const clearAppBarActions = useCallback(() => {
    setActions(null);
  }, []);

  const value = useMemo(() => ({
    actions,
    setAppBarActions,
    clearAppBarActions
  }), [actions, setAppBarActions, clearAppBarActions]);

  return (
    <AppBarActionsContext.Provider value={value}>
      {children}
    </AppBarActionsContext.Provider>
  );
};

export const useAppBarActions = () => {
  const context = useContext(AppBarActionsContext);
  if (!context) {
    return {
      actions: null,
      setAppBarActions: () => {},
      clearAppBarActions: () => {}
    };
  }
  return context;
};

